import { ReactNode } from "react";

import { SnackbarMessageActionsContext } from "../context";
import { useSnackbarMessageStore } from "../hooks/useSnackbarMessageStore";
import { SnackbarMessages } from "../SnackbarMessages";

export const SnackbarMessagesContextProvider = ({
  children,
}: {
  children: ReactNode;
}) => {
  const snackbarMessagesStore = useSnackbarMessageStore();
  return (
    <SnackbarMessageActionsContext.Provider
      value={snackbarMessagesStore.actions}
    >
      {children}
      <SnackbarMessages messages={snackbarMessagesStore.messages} />
    </SnackbarMessageActionsContext.Provider>
  );
};
